import { NgModule } from '@angular/core';
import { Http, HttpModule } from '@angular/http';
import { CommonModule } from '@angular/common';
import { ShareButtonsModule } from 'ngx-sharebuttons';
import { FormsModule } from '@angular/forms';
import { CurrencyMaskModule } from 'ng2-currency-mask';

import { RedirectEstablishmentComponent } from './redirect-establishment/redirect-establishment.component';
import { EstablishmentDetailComponent } from './establishment-detail/establishment-detail.component';
import { InternalRegistrationEstablishmentComponent } from './internal-registration-establishment/internal-registration-establishment.component';
import { OfferComponent } from './offer/offer.component';
import { AddressesComponent } from './addresses/addresses.component';
import { LogoComponent } from './logo/logo.component';
import { EstablishmentPartnershipComponent } from './partnership/establishment-partnership.component';
import { CreateSpecialDisclosureComponent } from './create-special-disclosure/create-special-disclosure.component';
import { OfferListComponent } from './offer-list/offer-list.component';
import { OfferCardComponent } from './offer-list/offer-card/offer-card.component';

import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { LightboxModule } from 'angular2-lightbox';
import { TranslateModule } from '@ngx-translate/core';
import { SelectModule } from 'ng2-select';
import { AccordionModule } from 'ngx-accordion';
import { TextMaskModule } from 'angular2-text-mask';
import { TagInputModule } from 'ngx-chips';
import { ModalModule } from '../../components/modal/modal.module';
import { CKEditorModule } from 'ckeditor4-angular';
import { MomentModule } from 'angular2-moment';

import { EstablishmentRoutingModule } from './establishment-routes';
import { ComponentsModule } from '../../components/components.module';

import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    ComponentsModule,
    CurrencyMaskModule,
    TranslateModule,
    HttpModule,
    ShareButtonsModule.forRoot(),
    LeafletModule.forRoot(),
    EstablishmentRoutingModule,
    SelectModule,
    AccordionModule,
    TextMaskModule,
    CKEditorModule,
    TagInputModule,
    ModalModule,
    LightboxModule,
    MomentModule,
    PipesModule
  ],
  declarations: [
    EstablishmentDetailComponent,
    InternalRegistrationEstablishmentComponent,
    OfferComponent,
    CreateSpecialDisclosureComponent,
    AddressesComponent,
    LogoComponent,
    EstablishmentPartnershipComponent,
    OfferListComponent,
    OfferCardComponent,
    RedirectEstablishmentComponent
  ],
  exports: [
    OfferCardComponent
  ],
  providers: []
})
export class EstablishmentModule {
}
